import { Component, ViewChild } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import * as Sentry from '@sentry/angular';
import { AlarmsCatalogKeys } from '../../models/AlarmsCatalogKeys';
import { AlarmService } from '../../services/Alarm.service';
import { FilterRequest } from 'src/app/features/shared/models/Filter/FilterRequest';
import { AlarmTableComponent } from '../../components/alarm-table/alarm-table.component';
import { SessionService } from 'src/app/features/shared/services/Session.service';

import { environment } from "src/environments/environment";
import { AlarmCatalogPaginationRequest } from 'src/app/features/shared/models/CatalogPagination/AlarmCatalogPaginationRequest';

@Component({
  selector: 'app-alarmPage',
  templateUrl: './alarmPage.component.html',
  styleUrls: ['./alarmPage.component.css']
})
export class AlarmPageComponent {

  @ViewChild(AlarmTableComponent) child;

  columnHeader: AlarmsCatalogKeys = {
    Icon: { displayName: "", filterable: false, activeFilter: null },
    AlarmCategory: { displayName: "Categoria Alarma", filterable: true, activeFilter: null },
    DetonatorName: { displayName: "Nombre Detonador", filterable: true, activeFilter: null },
    CreatedIn: { displayName: "Fecha", filterable: true, activeFilter: null },
    Hour: { displayName: "Hora", filterable: false, activeFilter: null },
    Identifier: { displayName: "Identificador", filterable: true, activeFilter: null },
    TotalTime: { displayName: "Tiempo Atn", filterable: false, activeFilter: null },
    StatusAlarm: { displayName: "Estado", filterable: true, activeFilter: null },
    AlarmDetails: { displayName: "Detalles", filterable: false, activeFilter: null },
  };

  catalogPaginationRequest: AlarmCatalogPaginationRequest = {
    page: 1,
    dato: "",
    getInactive: false,
    getSystem: false,
    filters: []
  }

  hasInactives: boolean = true;
  hasEditables: boolean = false;
  hasDeletables: boolean = false;
  filtersRequest : FilterRequest[] = [];
  filterOptions: { [key: string]: string[] } = {};

  tableData$: Observable<any[]> = new Observable<any[]>();
  tableData: any[];
  controllerName: string = "Alarm";
  paginador: number;

  subscription_getData: Subscription;
  subscription_getDataCount: Subscription;
  subscription_getDataFileterValues: Subscription;

  constructor(public alarmService: AlarmService, private sessionService: SessionService) {
  }

  ngOnInit() {
    this.sessionService.setIsExternalMap(false);
    this.EndSubscriptions();
    this.getFilters();
    this.getData();
  }

  ngOnDestroy(): void {
    this.EndSubscriptions();
  }

  EndSubscriptions(){
    if(this.subscription_getData)
      this.subscription_getData.unsubscribe();
    if(this.subscription_getDataCount)
      this.subscription_getDataCount.unsubscribe();
    if(this.subscription_getDataFileterValues)
      this.subscription_getDataFileterValues.unsubscribe();
  }

  getFilters(){
    var filterKeys = Object.keys(this.columnHeader).filter(key => this.columnHeader[key].filterable);
    this.filtersRequest = filterKeys.map(key => ({
      key: key,
      value: "" 
    }));
    this.subscription_getDataFileterValues = this.alarmService.getFilterValues(this.filtersRequest,).subscribe(data=>{
      filterKeys.forEach(column => {
        this.filterOptions[column] = data.result.find(x => x.key == column).values;
      });
      this.child.setFilterOptions(this.filterOptions);
      if(!environment.production) console.log("filterValues datos",data, this.filterOptions);
    },(error)=>{

    });
  }

  getData(){
    this.subscription_getDataCount = this.alarmService.getCount(this.catalogPaginationRequest).subscribe(data=>{
      if(!environment.production) console.log("alarm datos",data);
      this.paginador = data.result[0];
    },(error)=>{

    });
    this.subscription_getData = this.alarmService.getPage(this.catalogPaginationRequest).subscribe(data=>{
      if(!environment.production) console.log("alarm page 1",data);
      if(data.isSuccess==true)
      {
        // Apply condition on edit and delete button
      this.tableData = data.result;
      this.tableData.map(item => {
        item['IsEditable'] = this.hasEditables;
        item['IsDeletable'] = this.hasDeletables;
      });
      this.child.setData(this.tableData, this.paginador);

      } else {
        Sentry.captureMessage('AlarmPage.getData: respuesta sin éxito', { level: 'warning', extra: { response: data } });
      }
    },(error)=>{

    });
  }
}
